module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "break-tag"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "O600000002"
    }
  }, [_c('p', {
    staticClass: "para3"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "p20003ed5giii002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para7"
  }, [_c('strong', [_vm._v("Dorothy Garlock")])]), _vm._v(" "), _c('p', {
    staticClass: "para8"
  }, [_c('strong', [_vm._v("POPULAR LIBRARY")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "p20003ed5giii001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "break-tag"
  }), _vm._v(" "), _c('p', {
    staticClass: "para9"
  }, [_vm._v("An Imprint of Warner Books, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "para8"
  }, [_vm._v("A Time Warner Company")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-306f71a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/20003ed5frontv01.vue
// module id = 66
// module chunks = 0